import React from "react";
import IconButton from "./IconButton";
import ClickableIcon from "./ClickableIcon";
import styled from "styled-components";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import StyledButton, { StyledButtonSplitter } from "./StyledButton";
import { Dropdown } from "react-bootstrap";

// BsPrefixRefForwardingComponent<'button', ButtonProps>
export type Wp3ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    menu?: React.ReactNode | null
    variant?: ThemeVariant
};

const Button = React.forwardRef(({ menu, ...props } : Readonly<Wp3ButtonProps>, ref) => {
    const menuId = React.useId();
    if (menu) {
        return (
            <Dropdown ref={ref} as={ButtonGroup}>
                <StyledButton {...props} />
                <StyledButtonSplitter split variant={props['variant']} id={menuId} />
                {menu}
            </Dropdown>
        );
    }
    return <StyledButton ref={ref} {...props} />
});

export const DropdownToggleButton = styled(Button)`
    position: relative;
    text-align: left;
    width: 100%;

    &:after {
        position: absolute;
        right: 15px;
        bottom: 45%;
    }
`;

export default Button;
export {
    IconButton,
    ClickableIcon
};